module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTD11/z52/zx2/zx0/zx2/zp2/zx2/zJ+/yV+/zx0/zx2/zx0/zx2/z50/zx0/zx2/z52/5yT9VUAAAARdFJOUwCeJTlgwf31CgLh07eK63CvnNPEDQAAAMxJREFUOMuFk1kCxCAIQ3FFbN3uf9nR7u0o8mleAykKGm1p5RX0C8tR6wxYBkA8gTgAvD0AS33AnA5F9gFxAbpvkS5A9B1UmcQgnDjAeujGDQA90cEhrwMJXgeQLQExAOVKJOAs6jpQMg4UqkXmmjhficA1US2q5ghdx7CKyxrK08OJRWj5nqplLWE/c/stsnFZ77vuNiLLW99fw7cLJnLG3kB5TbqtbXl8/wFA+fJXnz8WLA/UvWQeICIpkHNojNPrxeBowyoJ4yNG/QNbKBRwxJU0WwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_phone.png
// module id = v9w9
// module chunks = 34